import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_4'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_4',
  name: 'Does the facility have any of the following safety measures in place for flooring?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'MEASURES_ARE_IN_PLACE_TO_PREVENT_WORKERS_FROM_SLIPPING_ON_FLOOR',
      text: 'Measures are in place to prevent workers from slipping on floors due to poor construction or lack of maintenance',
      externalIds: [
        {
          id: 'hs-9-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEASURES_ARE_IN_PLACE_TO_PREVENT_STANDING_WATER_DUE_TO_INADEQUA',
      text: 'Measures are in place to prevent standing water due to inadequate drainage',
      externalIds: [
        {
          id: 'hs-9-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEASURES_ARE_IN_PLACE_TO_PREVENT_FLOOR_OPENINGS_AND_OR_HOLES_MI',
      text: 'Measures are in place to prevent floor openings and/or holes missing covers/suitable barriers',
      externalIds: [
        {
          id: 'hs-9-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-9-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'MEASURES_ARE_IN_PLACE_TO_PREVENT_WORKERS_FROM_SLIPPING_ON_FLOOR',
                'MEASURES_ARE_IN_PLACE_TO_PREVENT_STANDING_WATER_DUE_TO_INADEQUA',
                'MEASURES_ARE_IN_PLACE_TO_PREVENT_FLOOR_OPENINGS_AND_OR_HOLES_MI',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13740,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
